import PropTypes from "prop-types"
import React from "react"

import CreatSomethingSpecial from "areas/info/create-something-special"
import { Route } from "helpers/sentry"

import InfoLayout from "./info-layout"
import InfoLayoutNew from "./info-layout-new"
import NoInfoLayout from "./no-info-layout"

const InfoRoute = ({
  component: Component,
  email,
  hidePageTitle,
  layout,
  paymentPrices,
  newLayout,
  title,
  showCta,
  removeLayout,
  isNewDesign,
  ...rest
}) => (
  <Route
    render={() => {
      if (newLayout) {
        return (
          <>
            <InfoLayoutNew {...{ hidePageTitle, isNewDesign, layout, title }}>
              <Component email={email} />
            </InfoLayoutNew>
            {showCta && <CreatSomethingSpecial />}
          </>
        )
      }
      if (removeLayout) {
        return (
          <>
            <NoInfoLayout {...{ layout, title }}>
              <Component email={email} />
            </NoInfoLayout>
          </>
        )
      }
      return (
        <>
          <InfoLayout {...{ layout, title }}>
            <Component email={email} paymentPrices={paymentPrices} />
          </InfoLayout>
          {showCta && <CreatSomethingSpecial />}
        </>
      )
    }}
    {...rest}
  />
)

InfoRoute.propTypes = {
  component: PropTypes.oneOfType([
    PropTypes.element,
    PropTypes.elementType,
    PropTypes.node,
  ]).isRequired,
  email: PropTypes.string,
  hidePageTitle: PropTypes.bool,
  isNewDesign: PropTypes.bool,
  layout: PropTypes.string,
  newLayout: PropTypes.bool,
  paymentPrices: PropTypes.object,
  removeLayout: PropTypes.bool,
  showCta: PropTypes.bool,
  title: PropTypes.string.isRequired,
}

export default InfoRoute
